import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import PageNotFound from '../../pages/PageNotFound';
import { accountSelector } from '../../store';
import type { SubscriptionType } from '../../types/Shared';

interface RequireSubscriptionProps {
  subscription: SubscriptionType;
}
const RequireSubscription = ({ subscription }: RequireSubscriptionProps) => {
  const { data: accountInfo } = useSelector(accountSelector);

  if (!accountInfo?.subscriptions.includes(subscription)) {
    return <PageNotFound statusCode='401' title='Subscription Required' subtitle='Your Account is not subscribed to this feature yet.' />;
  }

  return <Outlet />;
};

export default RequireSubscription;
